<template>
  <div>
    <div
      style="display: flex; flex-direction: column; height: 100%"
      v-if="this.data.packageInfo.length"
    >
      <van-nav-bar
        title="物流信息"
        left-arrow
        @click-left="goBack"
        :class="[
          'lmp-rewrite-am-navbar-light',
          not_iphonex ? 'notrem-lmp-rewrite-am-navbar-light-notiphonex' : '',
          iphonex && !not_iphonex
            ? 'notrem-lmp-rewrite-am-navbar-light-iphonex'
            : '',
        ]"
      />
      <div
        :class="[
          'lmp-card-header-wrap',
          not_iphonex ? 'notrem-lmp-card-header-wrap-notiphonex' : '',
          iphonex && !not_iphonex ? 'notrem-lmp-card-header-wrap-iphonex' : '',
        ]"
      >
        <img src="../../assets/img/myPackage/laba.png" alt="广播" />

        <van-notice-bar text="已拆分多个包裹，请注意查收～" scrollable />
      </div>
      <div class="lmp-wrap">
        <template v-for="(pkg, idx) in data.packageInfo">
          <div class="lmp-card-wrapper" :key="idx">
            <div class="lmp-card-wrap">
              <div class="lmp-card-body">
                <div v-if="pkg.status != '1'">
                  <div class="lmp-card-body-header">
                    <div class="lmp-card-body-header-left">
                      <img
                        src="../../assets/img/myPackage/packageIcon.png"
                        alt="包裹"
                      />
                      <span>包裹{{ idx + 1 }}</span
                      ><i style="display: inline-block"> | </i
                      ><span>{{ pkg.expressCompanyName }}</span>
                    </div>
                    <div class="lmp-card-body-header-right">
                      {{ pkg.statusName }}
                    </div>
                  </div>
                  <div
                    class="lmp-card-body-package"
                    @click="goDetail(pkg.otmsOrderNum)"
                  >
                    <p class="lmp-card-body-package-text">
                      <span>{{ pkg.track.operateInfo }}</span
                      ><img
                        src="../../assets/img/myPackage/arrow_grey_school.png"
                      />
                    </p>
                    <p class="lmp-card-body-package-time">
                      {{ pkg.track.operateTime }}
                    </p>
                  </div>
                </div>
                <div v-else class="lmp-card-body-header">
                  <div class="lmp-card-body-header-left">
                    <img
                      src="../../assets/img/myPackage/packageIcon.png"
                      alt="包裹"
                    />
                    <span>暂无包裹</span>
                  </div>
                  <div class="lmp-card-body-header-right">
                    {{ pkg.statusName }}
                  </div>
                </div>
                <div
                  v-if="pkg.showStatus == '展开'"
                  class="lmp-card-body-detail"
                  @click="goDetail(pkg.otmsOrderNum)"
                >
                  <template v-for="(good, i) in pkg.goods">
                    <p v-if="i < 2" :key="i">
                      教材{{ i + 1 }}：{{ good.name }}
                    </p>
                  </template>
                </div>
                <div
                  v-else
                  class="lmp-card-body-detail"
                  @click="goDetail(pkg.otmsOrderNum)"
                >
                  <p :key="i" v-for="(good, i) in pkg.goods">
                    教材{{ i + 1 }}：{{ good.name }}
                  </p>
                </div>
                <div class="lmp-card-body-body">
                  <span>共{{ pkg.goods.length }}件</span>
                  <div v-if="pkg.goods.length > 2">
                    <span
                      class="lmp-card-body-body-show"
                      @click="showAll(idx)"
                      >{{ pkg.showStatus }}</span
                    >
                    <img
                      :src="[
                        pkg.showStatus == '展开'
                          ? require('../../assets/img/myPackage/arrow_lower_grey@2x.png')
                          : require('../../assets/img/myPackage/arrow_upper_grey@2x.png'),
                      ]"
                      @click="showAll(idx)"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </template>
      </div>
    </div>
    <div
      v-if="this.data.packageInfo.length == 0 && !loading"
      style="text-align: center; background-color: #ffffff; height: 100%"
    >
      <van-nav-bar
        title="物流信息"
        left-arrow
        @click-left="goBack"
        :class="[
          'lmp-rewrite-am-navbar-light',
          not_iphonex ? 'notrem-lmp-rewrite-am-navbar-light-notiphonex' : '',
          iphonex && !not_iphonex ? 'lmp-rewrite-am-navbar-light-iphonex' : '',
        ]"
      />
      <div>
        <img
          src="../../assets/img/myPackage/noPackage.png"
          :class="[
            'lmp-wrap-empty',
            not_iphonex ? 'notrem-lmp-wrap-empty-notiphonex' : '',
            iphonex && !not_iphonex ? 'notrem-lmp-wrap-empty-iphonex' : '',
          ]"
          alt="暂无物流信息"
        />
        <p class="lmp-wrap-empty-text">未查询到包裹</p>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters, mapMutations } from "vuex";
import appUtil from "../../utils/appUtil";
export default {
  name: "multiple",
  data() {
    return {
      tab: "",
      bizId: "",
      data: {
        packageInfo: [],
      },
      not_iphonex: window.navigator.userAgent.includes("not_iphonex"),
      iphonex: window.navigator.userAgent.includes("iphonex"),
    };
  },
  computed: {
    ...mapGetters({
      loading: "getLoading",
    }),
  },
  created() {
    let isApp = new appUtil().isApp();
    if (isApp == "android" || isApp == "ios") {
      window.dhsdk.isShowNavigation({
        show: false,
      });
    }
    this.tab = this.$route.query.tab ? this.$route.query.tab : "";
    this.bizId = this.$route.query.bizId ? this.$route.query.bizId : "";
    if (!this.bizId) {
      this.$toast("获取bizId异常");
      return;
    }
    // window.mobile.isShowNavigation(false);
  },
  mounted() {
    this.getData();
    window.scrollTo(0, 0);
  },
  methods: {
    ...mapMutations({
      changeLoading: "changeLoading",
    }),
    goBack() {
      if (this.tab) {
        window.location.replace(
          `${location.origin}${location.pathname}#/myPackage?tab=${this.tab}`
        );
      } else {
        window.dhsdk.finishInterface();
      }
    },
    goDetail(id) {
      this.$router.push({
        path: "/logisticsDetail",
        query: {
          tab: this.tab,
          from: "multiple",
          bizId: this.bizId,
          otmsOrderNum: id,
        },
      });
    },
    showAll(index) {
      if (this.data.packageInfo[index].showStatus == "展开") {
        this.data.packageInfo[index].showStatus = "收起";
      } else {
        this.data.packageInfo[index].showStatus = "展开";
      }
    },
    // 获取包裹信息
    getData() {
      this.changeLoading(true);
      this.$api.my.getLogisticsInfo({ bizId: this.bizId }).then((res) => {
        this.changeLoading(false);
        if (res.ret) {
          let datas = res.data;
          if (datas.packageInfo.length) {
            datas.packageInfo.map((v) => {
              v.showStatus = "展开";
              return v;
            });
          }
          this.data = datas;
        } else {
          this.$toast(res.msg);
        }
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.fixNav {
  color: #333;
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  z-index: 999;
  height: 44px;
  box-sizing: content-box;
  border-bottom: 1px solid #f3f3f3;
}

.lmp-card-header-wrap {
  padding-top: 44px;
  position: relative;

  img {
    width: 14px;
    height: 14px;
    position: absolute;
    left: 14px;
    bottom: 10px;
  }
  .card-header {
    height: 34px !important;
    line-height: 34px !important;
    font-size: 12px !important;
    font-family: PingFangSC-Regular, PingFang SC !important;
    font-weight: 400;
    color: rgba(161, 109, 54, 1) !important;
    background-color: rgba(255, 242, 219, 1) !important;
    padding: 0 12px 0 24px;
    .am-notice-bar-content {
      margin: auto 0.14rem !important;
    }
  }
}
.notrem-lmp-card-header-wrap-iphonex {
  padding-top: calc(1.17333rem + 40px);
}
.notrem-lmp-card-header-wrap-notiphonex {
  padding-top: calc(1.17333rem + 20px);
}
.lmp-wrap {
  flex: 1;
  padding-top: 10px;
  padding-bottom: 40px;
  background-color: #f4f4f4;
  font-family: PingFangSC-Regular, PingFang SC;
  .lmp-card-wrapper {
    margin-top: 10px;
    padding: 0 12px;
    .lmp-card-wrap {
      background: rgba(255, 255, 255, 1);
      border-radius: 6px;
      padding: 16px;
      z-index: 10;
      transform: translateY(-8px);

      .lmp-card-body-header {
        display: flex;
        justify-content: space-between;
        padding-bottom: 16px;
        border-bottom: 1px solid #f2f2f2;
        align-items: center;
        &-left {
          font-size: 14px;
          line-height: 14px;
          color: rgba(51, 51, 51, 1);
          img {
            width: 20px;
            height: 20px;
            margin-right: 8px;
          }
          i {
            color: #e2e2e2;
            font-style: normal;
            margin: 0 8px;
          }
        }

        &-right {
          font-size: 14px;
          line-height: 14px;
          height: 14px;
          font-weight: 400;
          color: rgba(255, 121, 40, 1);
        }
      }
      .lmp-card-body-package {
        font-weight: 400;
        border-bottom: 1px solid rgba(242, 242, 242, 1);
        &-text {
          font-size: 14px;
          line-height: 14px;
          margin-top: 16px;
          color: #1082ff;
          span {
            display: inline-block;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            width: calc(100% - 15px);
          }
          img {
            width: 14px;
            height: 14px;
            float: right;
          }
        }
        &-time {
          font-size: 12px;
          line-height: 12px;
          color: #999;
          margin-top: 12px;
          margin-bottom: 16px;
        }
      }
      .lmp-card-body-detail {
        p {
          font-size: 14px;
          line-height: 20px;
          padding-top: 9px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #333;
        }
        p:last-of-type {
          padding-bottom: 8px;
        }
        p:first-of-type {
          padding-top: 15px;
        }
      }
      .lmp-card-body-body {
        line-height: 14px;
        height: 14px;
        display: flex;
        justify-content: flex-start;
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #999;
        img {
          width: 14px;
          height: 14px;
        }
        &-show {
          vertical-align: top;
          color: #666;
          margin-left: 10px;
          margin-right: 4px;
        }
      }

      .card-footer {
        display: flex;
        justify-content: flex-end;
        border-top: 1px solid rgba(242, 242, 242, 1);
        padding-top: 16px;

        &-btn-normal {
          width: 88px;
          height: 30px;
          border-radius: 15px;
          border: 1px solid rgba(226, 226, 226, 1);
          background-color: transparent;
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: rgba(102, 102, 102, 1);
          line-height: 14px;
          margin-left: 10px;
        }
      }
    }
  }
}
.lmp-rewrite-am-navbar-light {
  color: #333;
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  z-index: 999;
  height: 44px;
  box-sizing: content-box;
  border-bottom: 1px solid #f3f3f3;
}
.notrem-lmp-rewrite-am-navbar-light-iphonex {
  padding-top: 40px;
}
.notrem-lmp-rewrite-am-navbar-light-notiphonex {
  padding-top: 20px;
}

.lmp-wrap-empty {
  width: 100px;
  margin-top: 134px;

  &-text {
    margin-top: 16px;
    color: #333333;
    font-size: 14px;
  }
}
.notrem-lmp-wrap-empty-iphonex {
  margin-top: calc(5.06rem + 1.17333rem + 40px);
}
.notrem-lmp-wrap-empty-notiphonex {
  margin-top: calc(5.06rem + 1.17333rem + 20px);
}
.lmp-logistics-space {
  height: 10px;
}
</style>
